import axios from "axios"
import { baseURL } from "../config/api"

export const getVehicleClasses = (branchId: number, tenantId: string) => {
    return getFetch(`availableVehicleClass/${branchId}`, tenantId)
}

export const getVehicleClass = (primaryKey: string, tenantId: string) => {
    return getFetch(`vehicleClass/${primaryKey}`, tenantId);
}

export const post_VehicleIsNotAvailable = (data: any, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleIsNotAvailable/sendEmail`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}